/**
 * Filtra el catálogo de roles asignables en el selector de Usuarios.
 * Solo un usuario root puede asignar un rol root o supervisora (anti-escalada en UI;
 * respaldado por la regla anti-escalada de firestore.rules).
 *
 * @param {Array<{id:string,label?:string,isRoot:boolean}>} catalog
 * @param {boolean} currentUserIsRoot
 * @returns {Array} subconjunto asignable
 */
export const filterAssignableRoles = (catalog, currentUserIsRoot) =>
  (catalog || []).filter(r => currentUserIsRoot || (!r.isRoot && !r.isSupervisor));
